import * as yup from 'yup'
import { MULTI_HOTEL_FORM_STATE_TYPE } from './types'

import {
  LOCATION_REQUIRED,
  INVALID_DATE,
  CHILD_AGE_REQUIRED,
  BUNDLE_MAX_CAPACITY_ERROR
} from '../validation'

const MAXIMUM_BUNDLE_GUEST_COUNT = 8

const isChildrenAgeDataValid = (childrenAges: number[]) =>
  Array.isArray(childrenAges)
export const numOfValidAges = (childrenAges: number[]): number[] => {
  if (Array.isArray(childrenAges)) {
    return childrenAges.filter(age => age >= 0)
  }
  return []
}

function isChildrenAgeNotProvided(
  childrenCount: number,
  childrenAges: number[]
) {
  return (
    childrenCount > 0 &&
    isChildrenAgeDataValid(childrenAges) &&
    childrenCount !== numOfValidAges(childrenAges).length
  )
}

function handleChildrenAges(this: yup.TestContext) {
  const { childrenCount, childrenAges } = this
    .parent as MULTI_HOTEL_FORM_STATE_TYPE

  if (isChildrenAgeNotProvided(childrenCount, childrenAges)) {
    return this.createError({
      message: CHILD_AGE_REQUIRED,
      path: this.path
    })
  }

  return true
}

function handleRoomCapacity(this: yup.TestContext) {
  const { adultCount, childrenCount } = this
    .parent as MULTI_HOTEL_FORM_STATE_TYPE

  const travelerCount = adultCount + childrenCount
  const allowedTravelerCount = MAXIMUM_BUNDLE_GUEST_COUNT

  if (allowedTravelerCount < travelerCount) {
    return this.createError({
      message: BUNDLE_MAX_CAPACITY_ERROR,
      path: this.path
    })
  }

  return true
}

export const searchFormSchema = yup.object().shape({
  hotels: yup.array().of(
    yup.object().shape({
      endLocation: yup.object().nullable().required(LOCATION_REQUIRED),
      startDate: yup.string().nullable().required(INVALID_DATE),
      endDate: yup.string().nullable().required(INVALID_DATE)
    })
  ),
  childrenCount: yup.number().test({
    name: 'childrenCount',
    test: handleChildrenAges
  }),
  roomCount: yup.number().test({
    name: 'roomCount',
    test: handleRoomCapacity
  })
})
